// extracted by mini-css-extract-plugin
module.exports = {"colorTextFont":"ekuVqO","color":"GplHFn","oldColor":"x_HXFF","dropdown":"EHZqPm","oldDropdown":"sX06Sd","dropdownWidth":"omcydM","dropdownAlignment":"yrQ3J7"};